/* global axios */
import ApiClient from './ApiClient';

class ConversationForwardWhatsappAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  settings(conversationId) {
    return axios.get(`${this.url}/${conversationId}/forward_whatsapp/settings`);
  }

  summary(conversationId) {
    return axios.post(`${this.url}/${conversationId}/forward_whatsapp/summary`);
  }

  create(conversationId, params) {
    return axios.post(`${this.url}/${conversationId}/forward_whatsapp`, params);
  }
}

export default new ConversationForwardWhatsappAPI();
